import aa from "search-insights";
import { startAutocomplete } from "view/algolia/autocomplete";
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery.js'

/**
 * A Singleton class that handles the initial Algolia configuration.
 */
let instance = null;

export default class AlgoliaConfig {
    constructor()
    {
        if (! instance) {
            instance = this;
            this.initialised = false;
            this.moduleLoaded = false;
        }

        return instance;
    }

    init(appId, apiKey, index, userSessionToken, userAccountToken, suggestionsIndex, trackingEnabled, trackingCookieName)
    {
        if (!this.initialised) {
            this.appId = appId;
            this.apiKey = apiKey;
            this.index = index;
            this.userSessionToken = userSessionToken;
            this.userAccountToken = userAccountToken;
            this.suggestionsIndex = suggestionsIndex;
            this.trackingEnabled = trackingEnabled;
            this.startEventTrackingAndAutoComplete();
            this.initialised = true;
            this.itemsPerPage = 48;
            this.trackingCookieName = trackingCookieName;
        }
    }

    startEventTrackingAndAutoComplete()
    {
        if (this.trackingEnabled) {
            aa('init', {appId: this.appId, apiKey: this.apiKey});
            aa('setUserToken', this.userSessionToken);
            aa('setAuthenticatedUserToken', this.userAccountToken ? this.userAccountToken : undefined);
        }
        startAutocomplete(this.appId, this.apiKey, this.suggestionsIndex, this.trackingEnabled);
        this.createEventListeners();
    }

    createEventListeners()
    {
        $(window).on('OFL.productAddedOrRemovedFromCart', function (e, data) {
            if (!this.moduleLoaded) {
                this.moduleLoaded = true;
                import('./algoliaTracking').then((module) => {
                    (new module.default()).init(data);
                });
            }
        });
    }

    getAppId()
    {
        return this.appId;
    }

    getApiKey()
    {
        return this.apiKey;
    }

    getIndex()
    {
        return this.index;
    }

    isTrackingEnabled()
    {
        return this.trackingEnabled;
    }

    getUserSessionToken()
    {
        return this.userSessionToken;
    }

    getUserAccountToken()
    {
        return this.userAccountToken;
    }

    getItemsPerPage()
    {
        return this.itemsPerPage;
    }

    getSugestionsIndex()
    {
        return this.suggestionsIndex;
    }

    getTrackingCookieName()
    {
        return this.trackingCookieName;
    }

    getAnalyticsTags(namespace)
    {
        const analyticsTags = [];

        if (namespace === 'prodsearchp') {
            analyticsTags.push('search');
        } else if (namespace === 'homepage') {
            analyticsTags.push('homepage');
        } else if (namespace === 'prodshow') {
            analyticsTags.push('product-details');
        } else {
            analyticsTags.push('browse');
        }

        if (MediaQuery.current === 'small') {
            analyticsTags.push('mobile');
        } else {
            analyticsTags.push('desktop');
        }

        return analyticsTags;
    }
}